import { render, staticRenderFns } from "./Salarymanage_1.vue?vue&type=template&id=0cc4ee33&scoped=true&"
import script from "./Salarymanage_1.vue?vue&type=script&lang=js&"
export * from "./Salarymanage_1.vue?vue&type=script&lang=js&"
import style0 from "./Salarymanage_1.vue?vue&type=style&index=0&id=0cc4ee33&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc4ee33",
  null
  
)

export default component.exports